import { Component } from '@theme/component';

class JudgemeMedals extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.normalizeCount();

    this.observer = new MutationObserver(() => this.normalizeCount());
    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ['data-value'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    super.disconnectedCallback();
  }

  normalizeCount() {
    const wrapper = this.querySelector('.jdgm-medals-wrapper');
    const hasDirectRating = Boolean(
      wrapper && [...wrapper.children].some((child) => child.classList.contains('jdgm-rating'))
    );

    wrapper?.classList.toggle('lv-judgeme-medals--has-direct-rating', hasDirectRating);

    const countElements = this.querySelectorAll('.jdgm-rating__count[data-value]');
    if (!countElements.length) return;

    for (const countElement of countElements) {
      const count = Number.parseInt(countElement.dataset.value, 10);
      if (!Number.isFinite(count)) continue;

      const formatted = this.formatReviewCount(count, countElement.textContent);
      if (countElement.textContent.trim() !== formatted) {
        countElement.textContent = formatted;
      }
    }
  }

  formatReviewCount(count, currentText = '') {
    const locale = document.documentElement.lang || navigator.language || 'fr-CA';
    const label = currentText.toLowerCase().includes('review') || !locale.toLowerCase().startsWith('fr')
      ? 'reviews'
      : 'avis';

    if (count >= 1000) {
      return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(count / 1000)}K ${label}`;
    }

    return `${new Intl.NumberFormat(locale).format(count)} ${label}`;
  }
}

if (!customElements.get('judgeme-medals')) {
  customElements.define('judgeme-medals', JudgemeMedals);
}
